/*
 * Try-On Overlay — essayage virtuel (MediaPipe FaceMesh).
 * Extrait de sections/tryon-overlay.liquid pour être mis en cache par le
 * navigateur au lieu d'être retéléchargé dans le HTML à chaque navigation.
 * Les réglages de section arrivent via les attributs data- de #tryon-modal.
 */
(function () {
  'use strict';

  var CDN          = 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh@0.4.1633559619';
  var SMOOTH       = 0.55; // landmark EMA (0 = raw, 1 = fully frozen)

  // ── Built-in SVG glasses (fallback) ─────────────────────────────────────────
  var SVG_FRAMES = {
    round:  { svg: '<svg viewBox="0 0 300 80" xmlns="http://www.w3.org/2000/svg"><line x1="2" y1="38" x2="38" y2="37" stroke="#141414" stroke-width="6.5" stroke-linecap="round"/><ellipse cx="80" cy="43" rx="40" ry="31" fill="#080808" fill-opacity="0.74" stroke="#141414" stroke-width="5.5"/><path d="M120 41 C134 28 166 28 180 41" fill="none" stroke="#141414" stroke-width="4.5" stroke-linecap="round"/><ellipse cx="220" cy="43" rx="40" ry="31" fill="#080808" fill-opacity="0.74" stroke="#141414" stroke-width="5.5"/><line x1="262" y1="37" x2="298" y2="38" stroke="#141414" stroke-width="6.5" stroke-linecap="round"/></svg>', ar: 80/300 },
    rect:   { svg: '<svg viewBox="0 0 300 80" xmlns="http://www.w3.org/2000/svg"><line x1="2" y1="37" x2="39" y2="36" stroke="#2A1A0E" stroke-width="6.5" stroke-linecap="round"/><rect x="41" y="14" width="78" height="52" rx="9" fill="#2E180A" fill-opacity="0.7" stroke="#2A1A0E" stroke-width="5.5"/><line x1="119" y1="39" x2="181" y2="39" stroke="#2A1A0E" stroke-width="5" stroke-linecap="round"/><rect x="181" y="14" width="78" height="52" rx="9" fill="#2E180A" fill-opacity="0.7" stroke="#2A1A0E" stroke-width="5.5"/><line x1="261" y1="36" x2="298" y2="37" stroke="#2A1A0E" stroke-width="6.5" stroke-linecap="round"/></svg>', ar: 80/300 },
    cat:    { svg: '<svg viewBox="0 0 300 80" xmlns="http://www.w3.org/2000/svg"><line x1="2" y1="38" x2="35" y2="22" stroke="#141414" stroke-width="6.5" stroke-linecap="round"/><path d="M38 56 C38 22 52 10 80 10 C108 10 121 26 121 48 C121 62 106 67 80 67 C54 67 38 62 38 56Z" fill="#080808" fill-opacity="0.72" stroke="#141414" stroke-width="5.5"/><path d="M121 45 C135 30 165 30 179 45" fill="none" stroke="#141414" stroke-width="4.5" stroke-linecap="round"/><path d="M179 48 C179 26 192 10 220 10 C248 10 262 22 262 56 C262 62 246 67 220 67 C194 67 179 62 179 48Z" fill="#080808" fill-opacity="0.72" stroke="#141414" stroke-width="5.5"/><line x1="265" y1="22" x2="298" y2="38" stroke="#141414" stroke-width="6.5" stroke-linecap="round"/></svg>', ar: 80/300 },
    cobalt: { svg: '<svg viewBox="0 0 300 80" xmlns="http://www.w3.org/2000/svg"><line x1="2" y1="38" x2="39" y2="37" stroke="#1B3DDB" stroke-width="7" stroke-linecap="round"/><rect x="41" y="11" width="79" height="58" rx="4" fill="#1B3DDB" fill-opacity="0.42" stroke="#1B3DDB" stroke-width="6.5"/><line x1="120" y1="39" x2="180" y2="39" stroke="#1B3DDB" stroke-width="6" stroke-linecap="round"/><rect x="180" y="11" width="79" height="58" rx="4" fill="#1B3DDB" fill-opacity="0.42" stroke="#1B3DDB" stroke-width="6.5"/><line x1="261" y1="37" x2="298" y2="38" stroke="#1B3DDB" stroke-width="7" stroke-linecap="round"/></svg>', ar: 80/300 }
  };

  // ── State ───────────────────────────────────────────────────────────────────
  var isOpen = false, modelReady = false, modelLoading = false;
  var mediaStream = null, faceMesh = null;
  var smoothLm = null;           // EMA-smoothed landmarks
  var currentFrame = 0, frameData = {};
  var rafId = null, lastSend = 0, isSending = false;
  // cover-draw metrics (video → canvas mapping)
  var coverX = 0, coverY = 0, coverW = 0, coverH = 0;
  var stageW = 0, stageH = 0;

  // ── DOM ─────────────────────────────────────────────────────────────────────
  var modal      = document.getElementById('tryon-modal');
  var stage      = document.getElementById('tryon-stage');
  var video      = document.getElementById('tryon-video');
  var canvas     = document.getElementById('tryon-canvas');
  var loading    = document.getElementById('tryon-loading');
  var errorEl    = document.getElementById('tryon-error');
  var guide      = document.getElementById('tryon-guide');
  var captureBtn = document.getElementById('tryon-capture');
  var closeBtn   = document.getElementById('tryon-close');
  var framesEl   = document.getElementById('tryon-frames');

  if (!modal || !canvas || !framesEl) return;

  var ctx = canvas.getContext('2d');

  // ── Config (réglages de section, passés en attributs data- par Liquid) ──────
  var GLASSES_FILL = parseFloat(modal.getAttribute('data-glasses-fill')) || 0.70;
  var VERT_CENTER  = parseFloat(modal.getAttribute('data-vert-center'))  || 0.50;

  // ── Build product selector from Liquid-injected JSON ────────────────────────
  var productData = (function () {
    var el = document.getElementById('tryon-products-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();

  if (productData && productData.length) {
    framesEl.innerHTML = '';
    productData.forEach(function (p, i) {
      var btn = document.createElement('button');
      btn.className = 'tryon-frame-btn' + (i === 0 ? ' active' : '');
      btn.dataset.frameIndex = i;
      btn.dataset.frameImage = p.image;
      btn.innerHTML =
        '<div class="thumb-wrap"><img src="' + p.thumb + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy"></div>' +
        '<span class="thumb-label">' + p.title + '</span>';
      framesEl.appendChild(btn);
    });
  }

  // ── Image loading & white-background removal ─────────────────────────────────
  function loadImg(url) {
    return new Promise(function (res) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload  = function () { res(img); };
      img.onerror = function () { res(null); };
      img.src = url;
    });
  }

  function svgToImg(svgStr) {
    return new Promise(function (res) {
      var img  = new Image();
      var blob = new Blob([svgStr], { type: 'image/svg+xml;charset=utf-8' });
      var url  = URL.createObjectURL(blob);
      img.onload  = function () { URL.revokeObjectURL(url); res(img); };
      img.onerror = function () { URL.revokeObjectURL(url); res(null); };
      img.src = url;
    });
  }

  // Converts a loaded product image to a canvas with white background removed.
  // Returns an OffscreenCanvas-like element (or the original img on CORS failure).
  function removeWhiteBg(img) {
    var oc   = document.createElement('canvas');
    oc.width  = img.naturalWidth;
    oc.height = img.naturalHeight;
    var octx = oc.getContext('2d');
    octx.drawImage(img, 0, 0);
    try {
      var id = octx.getImageData(0, 0, oc.width, oc.height);
      var d  = id.data;
      for (var i = 0; i < d.length; i += 4) {
        var r = d[i], g = d[i+1], b = d[i+2];
        // Euclidean distance from pure white
        var dist = Math.sqrt((255-r)*(255-r) + (255-g)*(255-g) + (255-b)*(255-b));
        var lo = 30, hi = 80; // ramp from fully-transparent to fully-opaque
        if (dist < hi) {
          d[i+3] = dist <= lo ? 0 : Math.round(((dist - lo) / (hi - lo)) * d[i+3]);
        }
      }
      octx.putImageData(id, 0, 0);
      return { el: oc, useMul: false };
    } catch (e) {
      // CORS blocked pixel access → fall back to multiply blend
      return { el: img, useMul: true };
    }
  }

  function preloadFrames() {
    var btns  = Array.from(framesEl.querySelectorAll('.tryon-frame-btn'));
    var tasks = btns.map(function (btn) {
      var idx    = parseInt(btn.dataset.frameIndex, 10);
      var imgUrl = btn.dataset.frameImage;
      var style  = btn.dataset.frameStyle;

      if (imgUrl) {
        return loadImg(imgUrl).then(function (img) {
          if (!img) return;
          var result = removeWhiteBg(img);
          frameData[idx] = {
            img:       result.el,
            ar:        img.naturalHeight / img.naturalWidth,
            composite: result.useMul ? 'multiply' : 'source-over',
            isProduct: true
          };
        });
      }
      var g = SVG_FRAMES[style] || SVG_FRAMES.round;
      return svgToImg(g.svg).then(function (img) {
        frameData[idx] = { img: img, ar: g.ar, composite: 'source-over', isProduct: false };
      });
    });
    var timeout = new Promise(function (res) { setTimeout(res, 6000); });
    return Promise.race([Promise.all(tasks), timeout]);
  }

  // ── Landmark smoothing (exponential moving average, includes z for 3D) ────────
  function applySmoothing(newLm) {
    if (!smoothLm || smoothLm.length !== newLm.length) {
      smoothLm = newLm.map(function (p) { return { x: p.x, y: p.y, z: p.z || 0 }; });
    } else {
      for (var i = 0; i < newLm.length; i++) {
        smoothLm[i].x = SMOOTH * smoothLm[i].x + (1 - SMOOTH) * newLm[i].x;
        smoothLm[i].y = SMOOTH * smoothLm[i].y + (1 - SMOOTH) * newLm[i].y;
        smoothLm[i].z = SMOOTH * smoothLm[i].z + (1 - SMOOTH) * (newLm[i].z || 0);
      }
    }
    return smoothLm;
  }

  // ── Cover-fit metrics: maps video coords to canvas display coords ────────────
  function updateCover() {
    var vw = video.videoWidth, vh = video.videoHeight;
    var sw = canvas.width,     sh = canvas.height;
    if (!vw || !vh || !sw || !sh) return;
    var scale = Math.max(sw / vw, sh / vh);
    coverW = vw * scale;
    coverH = vh * scale;
    coverX = (sw - coverW) / 2;
    coverY = (sh - coverH) / 2;
  }

  // Convert a normalized landmark coordinate [0..1] to canvas pixel space
  function lx(lm, i) { return coverX + lm[i].x * coverW; }
  function ly(lm, i) { return coverY + lm[i].y * coverH; }

  // ── Glasses rendering — 3D face-aware placement ──────────────────────────────
  function drawGlasses(lm) {
    var fd = frameData[currentFrame];
    if (!fd || !fd.img) return;

    // ── Pupil positions (sub-pixel iris landmarks) ──────────────────────────
    var liX = lx(lm, 468), liY = ly(lm, 468);
    var riX = lx(lm, 473), riY = ly(lm, 473);

    // ── Nose bridge anchor (glasses rest here, not at pupil midpoint) ───────
    var nbX = lx(lm, 168), nbY = ly(lm, 168);

    // ── Face roll (head tilt) ────────────────────────────────────────────────
    var roll = Math.atan2(riY - liY, riX - liX);

    // ── Face yaw → perspective compression via 3D temple span ───────────────
    // Landmarks 234 / 454 = left & right outer face edges (include z depth)
    var le = lm[234], re = lm[454];
    var edx = re.x - le.x, edy = re.y - le.y, edz = (re.z || 0) - (le.z || 0);
    var span3D = Math.sqrt(edx*edx + edy*edy + edz*edz);
    var span2D = Math.sqrt(edx*edx + edy*edy);
    // cosTilt ∈ [0.35, 1]: horizontal compression factor (1 = frontal view)
    var cosTilt = span3D > 0.001 ? Math.min(1, Math.max(0.35, span2D / span3D)) : 1;

    // ── Glasses width from IPD ───────────────────────────────────────────────
    var ipd = Math.hypot(riX - liX, riY - liY);
    // IPD ≈ 44 % of frame total width; divide by GLASSES_FILL to get image width
    var gw = fd.isProduct ? (ipd / 0.44) / GLASSES_FILL : (ipd / 0.44);
    var gh = gw * fd.ar;

    // ── Glasses center: horizontal on pupil midpoint, vertical on nose bridge ─
    // VERT_CENTER = which row of the product image (0-1 from top) is the nose bridge.
    // We position the image so that row lands exactly on the nose bridge landmark.
    var cx = (liX + riX) / 2;
    var cy = fd.isProduct
      ? nbY + (0.5 - VERT_CENTER) * gh   // nose-bridge anchored
      : (liY + riY) / 2 + gh * 0.02;     // SVG: minor downward nudge

    // ── Draw with perspective ────────────────────────────────────────────────
    ctx.save();
    ctx.globalCompositeOperation = fd.composite;
    ctx.translate(cx, cy);
    ctx.rotate(roll);
    ctx.scale(cosTilt, 1);          // yaw perspective compression
    ctx.drawImage(fd.img, -gw / 2, -gh / 2, gw, gh);
    ctx.restore();
    ctx.globalCompositeOperation = 'source-over';
  }

  // ── Main render loop ─────────────────────────────────────────────────────────
  function mainLoop(ts) {
    if (!isOpen) return;

    var vw = video.videoWidth, vh = video.videoHeight;
    if (vw && vh) {
      // Resize canvas to match stage display size (not raw video size)
      var sw = stage.offsetWidth, sh = stage.offsetHeight;
      if (sw > 0 && sh > 0) {
        if (sw !== stageW || sh !== stageH) {
          canvas.width  = sw; stageW = sw;
          canvas.height = sh; stageH = sh;
          updateCover();
        }
        // Draw video with object-fit:cover logic (no distortion)
        ctx.clearRect(0, 0, sw, sh);
        ctx.drawImage(video, coverX, coverY, coverW, coverH);
        if (smoothLm) drawGlasses(smoothLm);
      }
    }

    // Throttle FaceMesh to ~30 fps
    if (!isSending && modelReady && vw && vh && ts - lastSend > 33) {
      lastSend = ts;
      isSending = true;
      faceMesh.send({ image: video })
        .catch(function () {})
        .finally(function () { isSending = false; });
    }

    rafId = requestAnimationFrame(mainLoop);
  }

  // ── MediaPipe ────────────────────────────────────────────────────────────────
  function loadScript(src) {
    return new Promise(function (res, rej) {
      if (document.querySelector('script[src="' + src + '"]')) { res(); return; }
      var s = document.createElement('script');
      s.src = src; s.crossOrigin = 'anonymous';
      s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  function initModel() {
    faceMesh = new window.FaceMesh({ locateFile: function (f) { return CDN + '/' + f; } });
    faceMesh.setOptions({
      maxNumFaces: 1,
      refineLandmarks: true,
      minDetectionConfidence: 0.6,
      minTrackingConfidence: 0.6
    });
    faceMesh.onResults(function (r) {
      if (r.multiFaceLandmarks && r.multiFaceLandmarks.length) {
        applySmoothing(r.multiFaceLandmarks[0]);
        guide.classList.remove('visible');
      } else {
        smoothLm = null;
        guide.classList.add('visible');
      }
    });
    return faceMesh.initialize();
  }

  // ── Camera ───────────────────────────────────────────────────────────────────
  function startCamera() {
    return navigator.mediaDevices.getUserMedia({
      video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } },
      audio: false
    }).then(function (stream) {
      mediaStream = stream;
      video.srcObject = stream;
      return new Promise(function (res) {
        video.onloadedmetadata = function () { video.play().then(res).catch(res); };
      });
    });
  }

  function stopCamera() {
    if (mediaStream) { mediaStream.getTracks().forEach(function (t) { t.stop(); }); mediaStream = null; }
    video.srcObject = null;
    smoothLm = null;
  }

  // ── Open / close ─────────────────────────────────────────────────────────────
  function openModal() {
    if (isOpen) return;
    isOpen = true;
    stageW = stageH = 0; // force canvas resize on next frame
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    loading.classList.remove('hidden');
    errorEl.classList.add('hidden');
    guide.classList.add('visible');

    var ready;
    if (modelReady) {
      ready = Promise.resolve();
    } else if (modelLoading) {
      ready = new Promise(function (res) {
        var t = setInterval(function () { if (modelReady) { clearInterval(t); res(); } }, 200);
      });
    } else {
      modelLoading = true;
      ready = loadScript(CDN + '/face_mesh.js')
        .then(initModel)
        .then(preloadFrames)
        .then(function () { modelReady = true; modelLoading = false; })
        .catch(function (e) { modelLoading = false; throw e; });
    }

    ready.then(startCamera)
      .then(function () {
        loading.classList.add('hidden');
        rafId = requestAnimationFrame(mainLoop);
      })
      .catch(function (err) {
        console.error('[TryOn]', err);
        loading.classList.add('hidden');
        errorEl.classList.remove('hidden');
      });
  }

  function closeModal() {
    if (!isOpen) return;
    isOpen = false;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    stopCamera();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  // ── Photo capture ─────────────────────────────────────────────────────────────
  function takePhoto() {
    if (!canvas.width || !canvas.height) return;
    var out  = document.createElement('canvas');
    out.width  = canvas.width;
    out.height = canvas.height;
    var octx = out.getContext('2d');
    // The canvas has CSS scaleX(-1); flip once more so the download matches what user sees
    octx.translate(out.width, 0);
    octx.scale(-1, 1);
    octx.drawImage(canvas, 0, 0);
    out.toBlob(function (blob) {
      var url = URL.createObjectURL(blob);
      var a   = document.createElement('a');
      a.href = url; a.download = 'grow-tryon.jpg';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 2000);
    }, 'image/jpeg', 0.93);
  }

  // ── Events ───────────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tryon-trigger]')) { e.preventDefault(); openModal(); }
  });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) closeModal(); });

  framesEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.tryon-frame-btn');
    if (!btn) return;
    Array.from(framesEl.querySelectorAll('.tryon-frame-btn')).forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    currentFrame = parseInt(btn.dataset.frameIndex, 10);
  });

  if (captureBtn) captureBtn.addEventListener('click', takePhoto);

})();
